import { FC, SVGAttributes } from 'react';

type CameraSquareSvgProps = SVGAttributes<SVGElement>;

export const CameraSquareSvg: FC<CameraSquareSvgProps> = ({ ...props }) => {
    return (
        <svg
            width="57"
            height="40"
            viewBox="0 0 57 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
                d="M37 0C38.6569 0 40 1.34315 40 3V13.585L55.2334 6.25586C55.8972 5.93671 56.667 6.42058 56.667 7.15723V32.8428C56.667 33.5794 55.8972 34.0633 55.2334 33.7441L40 26.4141V37C40 38.6569 38.6569 40 37 40H3C1.34315 40 6.44266e-08 38.6569 0 37V3C0 1.34315 1.34315 6.44255e-08 3 0H37ZM20.001 6.66699C20.0007 14.0303 14.0303 20.0006 6.66699 20.001L7.01074 20.0049C14.2154 20.1875 20.001 26.0853 20.001 33.334C20.001 25.9702 25.9702 20.001 33.334 20.001V20L32.9893 19.9951C25.7848 19.8125 20.0012 13.9154 20.001 6.66699Z"
                fill="#1F0A38"
            />
        </svg>
    );
};
